import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import { HelmetProvider } from 'react-helmet-async';

function isRecaptchaNoise(value) {
  const text = String(value?.message || value?.reason?.message || value || "");
  const source = String(value?.filename || value?.reason?.stack || "");
  return text.includes("reCAPTCHA") || source.includes("recaptcha");
}

function dismissRecaptchaOverlay() {
  const frame = document.getElementById("webpack-dev-server-client-overlay");
  const text = frame?.contentDocument?.body?.innerText || "";
  if (text.includes("reCAPTCHA")) frame.remove();
}

function ignoreRecaptchaNoise(event) {
  if (!isRecaptchaNoise(event)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  setTimeout(dismissRecaptchaOverlay, 0);
  setTimeout(dismissRecaptchaOverlay, 100);
}

window.addEventListener("error", ignoreRecaptchaNoise, true);
window.addEventListener("unhandledrejection", ignoreRecaptchaNoise, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </HelmetProvider>
);
